export default {

  props: {
    narrowLeft: Boolean,
  },

  data () {
    return {
      hasLeftSlot: null,
      hasRightSlot: null,
    }
  },

  computed: {
    classes () {
      return {
        'dual-pane': true,
        'dual-pane--narrow-left': this.narrowLeft,
        'has-left-pane': this.hasLeftSlot,
        'has-right-pane': this.hasRightSlot,
      }
    },
  },

  created () {
    this.checkSlots();
  },

  updated () {
    this.checkSlots();
  },

  methods: {
    checkSlots() {
      this.hasLeftSlot = this.$slots['left'] != null
      this.hasRightSlot = this.$slots['right'] != null
    },
  }
}